import {Component, OnInit, OnDestroy , ViewChild} from '@angular/core';
import {RestApiService} from '../rest-api.service';
import {MessageService} from '../message.service';
import {NgbModal , NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import {Router} from '@angular/router';
import {Formatters} from 'angular-slickgrid';
import {NotifierService} from 'angular-notifier';
import {Subscription} from 'rxjs';
import {FormControl} from '@angular/forms';
import {CloseScrollStrategy} from '@angular/cdk/overlay';


@Component({
    selector: 'app-role-user',
    templateUrl: './role-user.component.html',
    styleUrls: ['./role-user.component.css']
})
export class RoleUserComponent implements OnInit, OnDestroy {

    displayed = true;
    selected: number;
    clientSelected: number;
    roleSelected: number;
    userSelected: any;
    show: boolean;
    role_id: number;
    dataset: any[];
    totalData: number;
    selectedTitles: any[];
    respObject: any;
    clients = [];
    usrs = [];
    role = [];
    clientName: string;
    userName: string;
    roleName: string;
    notAdmin = true;

    displayData: any;

    add: boolean;
    del: boolean;
    edit: boolean;
    view: boolean;

    isError = false;
    errorMessage: string;
    nextOffset: number;
    previousOffset: number;
    pageSize: number;
    paginationType: string;
    page_no: number;
    totalPage: number;
    private userAuth: Subscription;
    private adminAuth: Subscription;
    private notifier: NotifierService;
    private clientId: number;
    private baseFlag: any;
    private cname: any;
    offset: number;
    dataLoaded: boolean;
    // userRoleMap: UserRoleMapping [] = [];

    showSearch = true;
    userId: number;
    userDtl = [];
    isLoading = false;
    searchUser: FormControl = new FormControl();
    searchData: FormControl = new FormControl();
    userSelected1: any;
    usrs1 = [];
    userName1: string;
    @ViewChild('scarch_content') private scarch_content;
    private searchModalReference: NgbModalRef;



    constructor(private _rest: RestApiService, private messageService: MessageService, private route: Router,
                private modalService: NgbModal, notifier: NotifierService) {
        this.notifier = notifier;
        this.messageService.getCellChangeData().subscribe(item => {
            switch (item.type) {
                case 'change':
                    console.log('changed');
                    if (!this.edit) {
                        this.notifier.notify('error', 'You do not have edit permission');
                    } else {

                    }
                    break;
                case 'delete':
                    if (this.baseFlag) {
                        if (!this.del) {
                            this.notifier.notify('error', 'You do not have delete permission');
                        } else {
                            this.deleteItem(item);
                        }
                    } else {
                        if (!this.messageService.del) {
                            this.notifier.notify('error', 'You do not have delete permission');
                        } else {
                            this.deleteItem(item);
                        }
                    }
                    break;
            }
        });
        this.messageService.getUserAuth().subscribe(details => {
            // console.log(JSON.stringify(details));
            if (details.length > 0) {
                this.add = details[0].addFlag;
                this.del = details[0].deleteFlag;
                this.view = details[0].viewFlag;
                this.edit = details[0].editFlag;
            }
        });
        this.messageService.getSelectedItemData().subscribe(selectedTitles => {
            if (selectedTitles.length > 0) {
                this.show = true;
                this.selected = selectedTitles.length;
            } else {
                this.show = false;
            }
        });
    }

    deleteItem(item) {
        if (confirm('Are you sure?')) {
            this._rest.deleteClientUserRoleMapping({id: item.id, user_id: this.messageService.getUserId()}).subscribe((res) => {
                this.respObject = res;
                if (this.respObject.success) {
                    this.messageService.sendAfterDelete(item.id);
                } else {
                    this.notifier.notify('error', this.respObject.errorMessage);
                }
            }, (err) => {
                this.notifier.notify('error', this.respObject.errorMessage);
            });
        }
    }

    ngOnInit() {
        this.userName = '';
        this.dataLoaded = false;
        this.nextOffset = 0;
        this.previousOffset = 0;
        this.pageSize = this.messageService.pageSize;
        this.page_no = 0;
        this.totalPage = 0;
        this.paginationType = 'next';
        this.displayData = {
            pageName: 'Maintain Role Mapping with User',
            openModalButton: 'Map Role with User',
            searchModalButton: 'Search',

            breadcrumb: 'ClientUserRoleMap',
            folderName: 'All Client User Role Map',
            tabName: 'Client Role Map'
        };
        const columnDefinitions = [
            {
                id: 'delete',
                field: 'id',
                excludeFromHeaderMenu: true,
                formatter: Formatters.deleteIcon,
                minWidth: 30,
                maxWidth: 30,
            },
            // {id: 'id', name: 'Id', field: 'id', sortable: true, filterable: true},
            {
                id: 'user_name', name: 'User ', field: 'user_name', sortable: true, filterable: true
            },
            {
                id: 'ROLE_NAME', name: 'Role ', field: 'role_name', sortable: true, filterable: true
            },
            {
                id: 'client_name', name: 'Client ', field: 'client_name', sortable: true, filterable: true
            }
        ];
        this.messageService.setColumnDefinitions(columnDefinitions);
        if (this.messageService.clientId) {
            this.clientId = this.messageService.clientId;
            this.baseFlag = this.messageService.baseFlag;
            this.clientName = this.messageService.client;

            this.onPageLoad();
        } else {
            this.userAuth = this.messageService.getClientUserAuth().subscribe(auth => {
                this.view = auth[0].viewFlag;
                this.add = auth[0].addFlag;
                this.edit = auth[0].editFlag;
                this.del = auth[0].deleteFlag;
                this.clientId = auth[0].clientId;
                this.baseFlag = auth[0].baseFlag;
                this.clientName = auth[0].client;
                this.onPageLoad();
            });
            this.adminAuth = this.messageService.getUserAuth().subscribe(details => {
                if (details.length > 0) {
                    this.add = details[0].addFlag;
                    this.del = details[0].deleteFlag;
                    this.view = details[0].viewFlag;
                    this.edit = details[0].editFlag;
                    this.clientId = details[0].clientId;
                    this.baseFlag = details[0].baseFlag;
                    this.clientName = details[0].client;
                    this.onPageLoad();
                }
            });
        }

        if (this.clientId !== 1) {
            this.clientSelected = this.clientId;
        }
        this.searchUser.valueChanges.subscribe(
            psOrName => {
                this.isLoading = true;
                const role_id = 0;
                if (psOrName !== '') {
                    this._rest.searchAllUser(this.clientSelected, psOrName, role_id).subscribe((res1) => {
                        this.respObject = res1;
                        this.isLoading = false;
                        if (this.respObject.success) {
                            this.usrs = this.respObject.details;
                        } else {
                            this.notifier.notify('error', this.respObject.errorMessage);
                        }
                    }, (err) => {
                        this.isLoading = false;
                        this.notifier.notify('error', this.messageService.SERVER_ERROR);
                    });
                } else {
                    this.isLoading = false;
                    this.userName = '';
                    this.usrs = [];
                }
            });
    }


    onPageLoad() {
        this.clientSelected = this.clientId;
        if (this.baseFlag) {
            this._rest.getClient().subscribe((res1) => {
                this.respObject = res1;
                this.notAdmin = false;
                if (this.respObject.success) {
                    this.respObject.clients.unshift({id: 0, name: 'Select Client'});
                    this.clients = this.respObject.clients;
                    this.clientSelected = 0;
                } else {
                    this.notifier.notify('error', this.respObject.errorMessage);
                }
            }, (err) => {
                this.notifier.notify('error', this.messageService.SERVER_ERROR);
            });
        } else {
            this.clientSelected = this.clientId;
            this._rest.getRoleClientWise(this.clientSelected).subscribe((res1) => {
                this.respObject = res1;
                if (this.respObject.success) {
                    this.isError = false;
                    this.respObject.roles.unshift({id: 0, name: 'Select Role'});
                    this.role = this.respObject.roles;
                    this.roleSelected = 0;
                } else {
                    this.isError = true;
                    this.errorMessage = this.respObject.errorMessage;
                }
            }, (err) => {
                this.isError = true;
                this.errorMessage = this.messageService.SERVER_ERROR;
            });
        }
        this.getTableData();
    }

    changeRouting(path: string) {
        this.messageService.changeRouting(path);
    }

    onClientChange(selectedIndex) {
        this.clientName = this.clients[selectedIndex].name;
        // console.log("==========="+this.clientName)
        this.userSelected = '';
        this.userName = '';
        this._rest.getRoleClientWise(this.clientSelected).subscribe((res) => {
            this.respObject = res;
            if (this.respObject.success) {
                this.isError = false;
                this.respObject.roles.unshift({id: 0, name: 'Select Role'});
                this.role = this.respObject.roles;
                this.roleSelected = 0;
            } else {
                this.isError = true;
                this.errorMessage = this.respObject.errorMessage;
            }
        }, (err) => {
            this.isError = true;
            this.errorMessage = this.messageService.SERVER_ERROR;
        });
    }

    openModal(content) {
        if (this.baseFlag) {
            if (!this.add) {
                this.notifier.notify('error', 'You do not have add permission');
            } else {
                this.isError = false;
                this.clientSelected = 0;
                this.roleSelected = 0;
                this.userSelected = '';
                this.modalService.open(content).result.then((result) => {
                }, (reason) => {
                });
            }
        } else {
            if (!this.messageService.add) {
                this.notifier.notify('error', 'You do not have add permission');
            } else {
                this.isError = false;
                this.roleSelected = 0;
                this.userSelected = '';
                this.modalService.open(content).result.then((result) => {
                }, (reason) => {

                });
            }
        }
    }


    searchModal() {
        if (this.baseFlag) {
                this.userSelected1 = '';
                this.searchModalReference = this.modalService.open(this.scarch_content);
                this.searchModalReference.result.then((result) => {
                }, (reason) => {
    
                });
            
        } else {
            
                 this.userSelected1 = '';
    
                this.searchModalReference = this.modalService.open(this.scarch_content);
                this.searchModalReference.result.then((result) => {
                }, (reason) => {
    
                });
            
        }
    }


    getUserDetails() {
        for (let i = 0; i < this.usrs.length; i++) {
            if (this.usrs[i].login_name === this.userSelected) {
                this.userId = this.usrs[i].id;
                this.userName = this.usrs[i].name;
            }
        }
    }


    getDetails() {
        for (let i = 0; i < this.usrs1.length; i++) {
            if (this.usrs1[i].user_name === this.userSelected1) {
                // this.userId = this.usrs1[i].id;
                this.userName1 = this.usrs1[i].user_name;
            }
        }
    }

    search() {
        this._rest.searchAllMapRoleWithUser(this.userSelected1, this.clientId).subscribe((res1) => {
            this.respObject = res1;
            this.isLoading = false;
            if (this.respObject.success) {
                this.usrs1 = this.respObject.details;
                this.messageService.setTotalData(this.usrs1.length);
                this.messageService.setGridData(this.usrs1);
                this.searchModalReference.close();

            } else {
                this.notifier.notify('error', this.respObject.errorMessage);
            }
        }, (err) => {
            this.isLoading = false;
            this.notifier.notify('error', this.messageService.SERVER_ERROR);
        });
    }


    save() {
        const data = {
            client_id: this.clientSelected,
            refer_user_id: this.userId,
            // user_id: this.userSelected,
            role_id: this.roleSelected
        };
        if (!this.messageService.isBlankField(data)) {
            this._rest.addUserRoleMapping(data).subscribe((res) => {
                this.respObject = res;
                if (this.respObject.success) {
                    // console.log("data"+JSON.stringify(this.respObject));
                    this.totalData = this.totalData + 1;
                    this.messageService.setTotalData(this.totalData);
                    this.isError = false;
                    const id = this.respObject.id;
                    this.messageService.setRow({id: id, user_name: this.userName, role_name: this.roleName, client_name: this.clientName});
                    if (this.totalData <= this.pageSize * this.page_no) {
                        this.offset = id;
                        this.nextOffset = 0;
                    } else {
                        this.nextOffset = this.offset;
                    }
                    if (this.baseFlag) {
                        this.clientSelected = 0;
                    }
                    this.userSelected = '';
                    this.roleSelected = 0;
                } else {
                    this.isError = true;
                    this.errorMessage = this.respObject.errorMessage;
                }
            }, (err) => {

            });
        } else {
            this.isError = true;
            this.errorMessage = this.messageService.BLANK_ERROR_MESSAGE;
        }
    }

    getTableData() {
        if (this.baseFlag) {
            if (!this.view) {
                this.notifier.notify('error', 'You do not have view permission');
            } else {
                this.getNewTableData({'offset': this.nextOffset, 'paginationType': ''});
            }
        } else {
            if (!this.messageService.view) {
                this.notifier.notify('error', 'You do not have view permission');
            } else {
                this.getNewTableData({'offset': this.nextOffset, 'paginationType': ''});
            }
        }
    }

    isEmpty(obj) {
        for (const key in obj) {
            if (obj.hasOwnProperty(key)) {
                return false;
            }
        }
        return true;
    }

    getNewTableData(paginationObj) {
        const offset = paginationObj.offset;
        const paginationType = paginationObj.paginationType;
        this.dataLoaded = false;
        this._rest.getUserRolesMap(this.baseFlag, this.clientId, offset, this.pageSize, paginationType).subscribe((res) => {
            this.respObject = res;
            // console.log()
            this.executeResponse(this.respObject, offset, paginationType);
        }, (err) => {
            this.notifier.notify('error', JSON.stringify(err));
        });
    }

    executeResponse(respObject, offset, paginationType) {
        if (respObject.success) {
            this.dataLoaded = true;
            if (offset === 0) {
                this.totalData = respObject.usrRoleMap.totalData[0].count;
                this.totalPage = respObject.usrRoleMap.totalPage;
                if (this.totalPage === 0) {
                    this.totalPage = 1;
                }
            }
            if (!this.isEmpty(respObject.usrRoleMap.dataObj)) {
                const data = respObject.usrRoleMap.dataObj;
                this.nextOffset = respObject.usrRoleMap.nextOffset;
                this.offset = respObject.usrRoleMap.nextOffset;
                this.previousOffset = respObject.usrRoleMap.previousOffset;
                this.messageService.setTotalData(this.totalData);
                this.messageService.setGridData(data);
                // ----------------------------------------------
                if (offset !== 0) {
                    const totalCount = this.totalData;
                    const divRes = totalCount / this.pageSize;
                    const remainder = totalCount % this.pageSize;
                    if (remainder === 0) {
                        this.totalPage = parseInt(String(divRes), 10);
                    } else {
                        this.totalPage = parseInt(String(divRes), 10) + 1;
                    }
                }
                // ------------------------------------------------
                if (paginationType === 'next') {
                    this.page_no = this.page_no + 1;
                } else if (paginationType === 'prev') {
                    this.page_no = this.page_no - 1;
                } else if (paginationType === '' && this.page_no === 0) {
                    this.page_no = this.page_no + 1;
                }
                if (this.totalData <= this.pageSize * this.page_no) {
                    this.nextOffset = 0;
                }
            } else if (this.isEmpty(respObject.usrRoleMap.dataObj) && paginationType === 'next') {
                this.nextOffset = 0;
            } else if (this.isEmpty(respObject.usrRoleMap.dataObj) && paginationType === 'prev') {
                this.previousOffset = 0;
            } else if (paginationType === '' && this.page_no === 0) {
                this.page_no = this.page_no + 1;
            }
        } else {
            this.notifier.notify('error', respObject.errorMessage);
        }
    }

    onRoleChange(selectedIndex: any) {
        this.roleName = this.role[selectedIndex].name;
    }

    onPageSizeChange(value: any) {
        this.page_no = 0;
        this.nextOffset = 0;
        this.pageSize = value;
        this.getNewTableData({'offset': this.nextOffset, 'paginationType': ''});
    }

    ngOnDestroy(): void {
        if (this.userAuth) {
            this.userAuth.unsubscribe();
        }
        if (this.adminAuth) {
            this.adminAuth.unsubscribe();
        }
    }


}
